import styled from 'styled-components';

export default styled.div`
  flex: 0 0 48px;
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid var(--grey200);
  color: var(--grey800);
`;
